import {
  FiArrowUpRight,
  FiArrowLeft,
  FiCodepen,
  FiFigma,
  FiFramer,
  FiGithub,
  FiGrid,
  FiLoader,
  FiMail,
  FiMapPin,
  FiMenu,
  FiPhone,
  FiSend,
  FiTrendingUp,
  FiTwitter,
  FiX
} from 'react-icons/fi';
import {
  FaInstagram,
  FaLinkedinIn,
  FaRedditAlien,
  FaDiscord,
  FaFacebookMessenger,
  FaSkype,
  FaTelegramPlane
} from 'react-icons/fa';
import { SiOpenai, SiX } from 'react-icons/si';

export const iconRegistry = {
  FiArrowUpRight,
  FiArrowLeft,
  FiCodepen,
  FiDiscord: FaDiscord,
  FiFigma,
  FiFramer,
  FiGithub,
  FiGrid,
  FiLoader,
  FiMail,
  FiMapPin,
  FiMenu,
  FiPhone,
  FiSend,
  FiTrendingUp,
  FiTwitter,
  FiX,
  FaDiscord,
  FaInstagram,
  FaLinkedinIn,
  FaFacebookMessenger,
  FaRedditAlien,
  FaSkype,
  FaTelegramPlane,
  SiX,
  SiOpenai
};
